













































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Blacklist } from '@/interfaces/blacklist';
import CompanyList from '@/components/search-components/list-items/company-list.vue';
import DropdownOrderBy from '@/components/dropdowns/dropdown-order-by.vue';
import { List } from '@/interfaces/list';
import { ListItems } from '@/interfaces/list-items';
import moment from 'moment';
import ProcurementList from '@/components/search-components/list-items/procurement-list.vue';
import { ProcurementSearchItem } from '@/interfaces/search/procurement-search-item';
import ProjectList from '@/components/search-components/list-items/project-list.vue';
import { ProjectSearchItem } from '@/interfaces/search/project-search-item';
import SearchInput from '@/components/form-fields/search-input.vue';
import { SearchItemTypes } from '@/util/enums/search-item-types';
import { TranslateResult } from 'vue-i18n';

@Component({
  components: {
    CompanyList,
    DropdownOrderBy,
    ProcurementList,
    ProjectList,
    SearchInput,
  },
})
export default class ListOverview extends Vue {
  @Prop({ required: true }) listItems: ListItems;
  @Prop({ required: true }) list: List;
  @Prop({ default: null }) onPersistBlacklist: (blacklist: Blacklist) => Promise<Blacklist>;

  listItemsResult: ListItems = {
    listId: null,
    procurements: [],
    projects: [],
    companies: [],
  };

  orderByData: TranslateResult = null;
  orderByDecendingData = true;
  showBlacklists = false;
  selectedType: SearchItemTypes = SearchItemTypes.PROJECT;
  limit = 20;
  showMoreLimit = 20;
  filterTextData = '';

  projectSortingOptions: [TranslateResult, (a: ProjectSearchItem, b: ProjectSearchItem) => number][] = [
    [ this.$t('components.sorting.updated'), this.compareObjectByLastUpdated ],
    [ this.$t('components.sorting.contractSum'), (a, b) => b.budget - a.budget ],
    [ this.$t('components.sorting.published'),   (a, b) => moment(a.published).isBefore(moment(b.published)) ? 1 : -1 ],
  ]

  procurementSortingOptions: [TranslateResult, (a: ProcurementSearchItem, b: ProcurementSearchItem) => number][] = [
    [ this.$t('components.sorting.updated'),     this.compareObjectByLastUpdated ],
    [ this.$t('components.sorting.contractSum'), (a, b) => b.budget - a.budget ],
    [ this.$t('components.sorting.published'),   (a, b) => moment(a.published).isBefore(moment(b.published)) ? 1 : -1 ],
  ]

  created() {
    this.orderBy = this.projectSortingOptions[0][0];
  }

  mounted() {
    this.sort();
  }

  get filterCompanies() {
    return [...this.listItems.companies]
      .filter(item => item.name.toLowerCase().includes(this.filterText.toLowerCase()))
  }

  get filterProcurements() {
    return [...this.listItems.procurements]
      .filter(item => item.name.toLowerCase().includes(this.filterText.toLowerCase()))
      .filter(item => this.showBlacklists || !this.$vmx.blacklist.isIdOnUserBlacklist(item.id, 'Procurement'))
      .sort(this.procurementSortingMethod)
  }
  
  get filterProjects() {
    return [...this.listItems.projects]
      .filter(item => item.name.toLowerCase().includes(this.filterText.toLowerCase()))
      .filter(item => this.showBlacklists || !this.$vmx.blacklist.isIdOnUserBlacklist(item.id, 'Project'))
      .sort(this.projectSortingMethod)
  }

  get filterText() {
    return this.filterTextData;
  }

  set filterText(val: string) {
    this.filterTextData = val;
  }

  get orderBy(): TranslateResult {
    return this.orderByData;
  }

  set orderBy(value: TranslateResult) {
    this.orderByData = value;
  }

  get orderByDesc() {
    return this.orderByDescending ? 'desc' : 'asc'
  }

  set orderByDesc(val: string) {
    this.orderByDescending = val === 'desc';
    this.sort();
  }

  get orderByDescending() {
    return this.orderByDecendingData;
  }

  set orderByDescending(value) {
    this.orderByDecendingData = value;
  }

  get procurementSortingMethod(): (a: ProcurementSearchItem, b: ProcurementSearchItem) => number {
    const method = this.procurementSortingOptions.find(option => option[0] === this.orderBy.toString())[1];
    return (a,b) => this.orderByDescending ? method(a, b) : method(b, a);
  }

  get projectSortingMethod(): (a: ProjectSearchItem, b: ProjectSearchItem) => number {
    const method = this.projectSortingOptions.find(option => option[0] === this.orderBy.toString())[1];
    return (a,b) => this.orderByDescending ? method(a, b) : method(b, a);
  }

  get showAddtoLimit(): boolean {
    let length = 0;
    switch (this.selectedType) {
      case SearchItemTypes.PROJECT:
        length = this.listItemsResult.projects.length;
        break;
      case SearchItemTypes.PROCUREMENT:
        length = this.listItemsResult.procurements.length;
        break
      case SearchItemTypes.COMPANY:
        length = this.listItemsResult.companies.length;
        break;
    }
    return this.limit <= length;
  }
  

  get sortingOptions(): TranslateResult[] {
    switch (this.selectedType) {
      case SearchItemTypes.PROJECT:
        return this.projectSortingOptions.map((o) => o[0]);
      case SearchItemTypes.PROCUREMENT:
        return this.procurementSortingOptions.map((o) => o[0]);
      case SearchItemTypes.COMPANY:
      default:
        return [];
    }
  }

  @Watch('listItems')
  @Watch('listView')
  @Watch('$vmx.blacklist.blacklists')
  @Watch('showBlacklists')
  sort() {
    this.listItemsResult = {
      listId: this.listItems.listId,
      projects: this.filterProjects,
      procurements: this.filterProcurements,
      companies: this.filterCompanies,
    }
  }

  @Watch('selectedType')
  @Watch('filterTextData')
  @Watch('orderByData')
  @Watch('orderByDecendingData')
  @Watch('showBlacklists')
  initLimit() {
    this.limit = this.showMoreLimit;
  }

  addToLimit() {
    this.limit = this.limit + this.showMoreLimit;
  }

  compareObjectByLastUpdated <T>(a: T, b: T): number {
    if (!a['lastUpdated' as keyof T]) return 1;
    if (!b['lastUpdated' as keyof T]) return -1;
    return moment(a['lastUpdated' as keyof T]).isAfter(moment(b['lastUpdated' as keyof T])) ? -1 : 1;
  }

  toggleShowBlacklist() {
    this.showBlacklists = !this.showBlacklists;
  }
}
